import { useEffect } from 'react';
import { getTranslationFromTranslatableEntity } from '../../constants/matter';
import { useSelectBusinessArea } from '../../hooks/useSelectBusinessArea';
import { Radio, RadioGroup, Spin, Text } from '../Ant';
import NoData from '../dashboard/noData';
import { GeneralEmpty } from '../icons';
import SearchInputWithFilters from '../dashboard/SearchInputWithFilters';
import { usePage } from '../../context/PageContext';
import AddEditTransactionHeader from '../dashboard/addTransaction/addEditTransactionHeader';
import { useNavigationStack } from '../../context/NavigationStackContext';
import SkeletonOptionList from '../common/skeleton/skeletonOptionList';
import CollapsibleListLayout from '../collapsibleListLayout/collapsibleListLayout';
import { IBusinessArea } from '../../interface/businessArea';

const SelectBusinessArea = () => {
  const {
    t,
    appLanguage,
    businessAreaList,
    isLoading,
    isFetching,
    setSearchValue,
    paginationRef,
    hasNextPage,
    refreshBusinessAreaList,
    handleSelectBusinessArea,
    currentValue,
  } = useSelectBusinessArea();
  const { setTitle } = usePage();
  const { goBack } = useNavigationStack();

  const handleBack = () => {
    goBack();
  };

  useEffect(() => {
    setTitle(
      <AddEditTransactionHeader
        handleBack={handleBack}
        showCross
        title={t('matterRequest:selectBusinessArea')}
      />,
    );
  }, []);

  return (
    <CollapsibleListLayout
      testId="business-area-selection"
      header={
        <SearchInputWithFilters
          searchTitle={t('matterRequest:searchBusinessAreas')}
          handleSearch={(val) => setSearchValue(val)}
          handleRefresh={refreshBusinessAreaList}
        />
      }
    >
      {businessAreaList && businessAreaList.length > 0 && (
        <RadioGroup
          data-testid="radio-group"
          className="d-flex fd-column gap-10"
          value={currentValue}
        >
          {businessAreaList.map((businessArea: IBusinessArea) => (
            <Radio
              key={businessArea.id}
              value={businessArea.id}
              data-testid={`business-area-radio-${businessArea.id}`}
              onClick={() => handleSelectBusinessArea(businessArea)}
            >
              <Text $fontsize="13px" $color="title" $weight={500} $lineheight="20px">
                {getTranslationFromTranslatableEntity(businessArea.translations, appLanguage)}
              </Text>
            </Radio>
          ))}
        </RadioGroup>
      )}
      {hasNextPage && <div ref={paginationRef} className="loading-indicator" />}
      {(!businessAreaList || (businessAreaList.length === 0 && !isLoading)) && (
        <div
          className="flex-grow d-flex justify-center items-center"
          role="status"
          aria-live="polite"
        >
          <NoData
            header={t('matterRequest:noBusinessAreas')}
            subHeader={t('common:tryChangingSearchCriteria')}
            icon={<GeneralEmpty />}
          />
        </div>
      )}
      {isLoading ? (
        <SkeletonOptionList />
      ) : (
        isFetching && <Spin size="small" data-testid="small-indicator" />
      )}
    </CollapsibleListLayout>
  );
};

export default SelectBusinessArea;
